import { formatPrice } from '../../../utils/functions/data.functions';
import { ColDataType, TableColumn } from '../../table/DataTable.types';

export const columns = () =>
  [
    {
      accessor: 'validFrom',
      name: 'page.code-book-item-price.col-valid-from',
      dataType: ColDataType.DATE,
    },
    {
      accessor: 'currency',
      name: 'page.code-book-item-price.col-currency',
    },
    {
      accessor: 'vatCodeId',
      name: 'page.code-book-item-price.col-vat-code',
      cellRenderer(e) {
        if (!e || !e.vatCode) return '';
        return <span>{e.vatCode?.code + ': ' + e.vatCode?.coefficientPercent + '%'}</span>;
      },
    },
    {
      accessor: 'price',
      name: 'page.code-book-item-price.col-price',
      className: `text-right ml-auto`,
      cellRenderer(e) {
        return <span>{formatPrice(e.price)}</span>;
      },
    },
    {
      accessor: 'unit',
      name: 'page.code-book-item-price.col-unit',
    },
  ] as TableColumn[];
